import { useState } from 'react';
import styles from './styles.module.css';
import { productCardType } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';
import IncreaseDecreaseButtons from '../../ProductsContent/ProductCard/IncreaseDecreaseButtons';
import AddToCartButton from '../../ProductsContent/ProductCard/AddToCartButton';
import MainIcons from '@/icons/main';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import AppLink from '@/components/common/AppLink';

type Props = {
  product?: productCardType;
  onAddToCart?: (quantity: number) => void;
};

const formatPrice = (value: number) => value.toLocaleString('fa-IR');

export default function PurchaseCard({ product, onAddToCart }: Props) {
  const [quantity, setQuantity] = useState(1);
  const { priceSymbol } = useLayoutContext();
  const [count, setCount] = useState(1);

  const callBackify = (value?: number, type?: string) => {
    if (type == 'plus') {
      setCount(count + 1);
    } else {
      setCount(count - 1);
    }
  };
  const guarantees = [
    {
      icon: <MainIcons.shieldIcon fill="var(--brand-deep)" width="17px" height="17px" />,
      title: 'گارانتی اصالت و سلامت کالا',
    },
    {
      icon: <MainIcons.returnIcon fill="var(--purple)" width="17px" height="17px" />,
      title: '۷ روز ضمانت بازگشت',
    },
  ];
  return (
    <aside className={styles.card}>
      {product?.discount && (
        <div className={styles.oldPriceRow}>
          <span className={styles.oldPrice}>{formatPrice(Number(product?.price))}</span>

          <span className={styles.discount}>{product?.discount?.value}٪-</span>
        </div>
      )}

      <PriceSection
        value={product?.discount?.price ? product?.discount?.price : product?.price}
        className={styles.price}
      />

      <div className={styles.features}>
        <div className={styles.feature}>
          <MainIcons.truckIcon fill="var(--green)" />

          {product?.shipping?.title}
          {' — '}
          <strong>{product?.shipping?.delivery}</strong>
        </div>

        {guarantees?.map((item) => (
          <div key={item.title} className={styles.feature}>
            {item?.icon}

            {item.title}
          </div>
        ))}
      </div>

      {Number(product?.inventory?.quantity) > 0 && (
        <div className={styles.stock}>
          <svg width={15} height={15}>
            <use href="#ic-check" />
          </svg>
          موجود در انبار — تنها {product?.inventory?.quantity} عدد باقی مانده
        </div>
      )}

      <div className={styles.quantityRow}>
        <span>تعداد</span>
        <IncreaseDecreaseButtons
          item={product}
          count={count}
          callback={(value: number, type: string) => callBackify(value, type)}
          fromBasket={false}
        />
      </div>

      <AddToCartButton
        item={product}
        productCount={count}
        text="افزودن به سبد خرید"
        icon={<MainIcons.basketIcon fill="var(--paper)" />}
        parentClassName="w-full"
        className={`w-full squareButton mb-18`}
      />

      <AppLink title="سبد خرید" href="/cart" className={styles.cartLink}>
        مشاهدهٔ سبد خرید
      </AppLink>
    </aside>
  );
}
